import { defineStore } from 'pinia';

export const UseOrderStore = defineStore('orderStore', {
    state: () => ({
        order: '',  // This will store the order number
        email: '',
        message: ''
    }),
    actions: {
        setcode(order) {
            this.order = order;  // Set the order number
        },
        setEmail(email) {
            this.email = email;  // Set the order number
        },
        $reset() {
            this.order = '';
            this.email = '';
            this.message = '';
        }
    },
    persist: true
});





